import React, { useState } from 'react';
import { v4 as uuid } from 'uuid';

import BrandSelect from 'src/components/brand-select';
import { GqlBrand, GqlCustomNavigationItem, CustomNavigationItemType } from 'types/graphql';

import { ModalControllerProps } from './modal-controller';
import { BaseCustomNavigationModal } from './base-custom-navigation-modal';

type BrandOption = {
  key: string;
  label: string;
  value: GqlBrand;
};

export function AddBrandModal({ editingItem, onClose, onSave }: ModalControllerProps): JSX.Element {
  const [selectedBrand, setSelectedBrand] = useState<BrandOption | null>(null);
  const [label, setLabel] = useState(editingItem?.label ?? '');

  const isEditing = !!editingItem;
  const isValid = (!!selectedBrand?.value.id || isEditing) && label.trim() !== '';

  const handleChangeBrand = (brandOption: BrandOption | null): void => {
    setSelectedBrand(brandOption);
    if (brandOption && !label) {
      setLabel(brandOption.label);
    }
  };

  const handleSave = (): void => {
    if (!isValid) {
      return;
    }

    const item: GqlCustomNavigationItem = {
      id: editingItem?.id ?? uuid(),
      items: editingItem?.items ?? [],
      label: label.trim(),
      navigationType: CustomNavigationItemType.brand,
      connectedId: selectedBrand?.value.id ?? editingItem?.connectedId,
      position: editingItem?.position ?? 0,
    };

    onSave(item);
    onClose();
  };

  return (
    <BaseCustomNavigationModal
      copy='Connect to a brand page.'
      handleSave={handleSave}
      headerText='Brand'
      inputLabel={label}
      isEditing={isEditing}
      isOpen
      isValid={isValid}
      onClose={onClose}
      setLabel={setLabel}
    >
      <BrandSelect brand={selectedBrand?.value} onChange={handleChangeBrand} placeholder='Select a brand' width={348} />
    </BaseCustomNavigationModal>
  );
}
